/**
 * Labels dinámicos según el tipo de usuario (coach / comercial).
 * Centraliza las cadenas que cambian entre tipos de usuario.
 */

const LABELS = {
  coach: {
    sesiones: 'Sesiones',
    sesion: 'Sesión',
    sesiones_lower: 'sesiones',
    sesion_lower: 'sesión',
    todas_sesiones: 'Todas las sesiones',
    resumen_sesiones: 'Resumen de sesiones',
    nueva_sesion: 'Nueva sesión',
    editar_sesion: 'Editar sesión',
    numero_sesion: 'Nº de sesión',
    buscar_placeholder: 'Buscar clientes, citas, sesiones...',
    tipo_label: 'Coach',
  },
  comercial: {
    sesiones: 'Reuniones',
    sesion: 'Reunión',
    sesiones_lower: 'reuniones',
    sesion_lower: 'reunión',
    todas_sesiones: 'Todas las reuniones',
    resumen_sesiones: 'Resumen de reuniones',
    nueva_sesion: 'Nueva reunión',
    editar_sesion: 'Editar reunión',
    numero_sesion: 'Nº de reunión',
    buscar_placeholder: 'Buscar clientes, citas, reuniones...',
    tipo_label: 'Comercial',
  },
};

/**
 * Obtiene los labels para un tipo de usuario dado.
 * @param {string} tipoUsuario - 'coach' o 'comercial'
 * @returns {object} Labels correspondientes
 */
export function getLabels(tipoUsuario) {
  return LABELS[tipoUsuario] || LABELS.coach;
}

export default LABELS;
